import * as yup from 'yup'
import { getPONumber } from 'src/deps'

const PONumberSchema = Object.assign({}, getPONumber())
export const schema = yup.object(PONumberSchema)
